import { EsteiraModelo } from "./esteira_modelo";
import { ProdutoIdadeCartao } from "./produtoIdadeCartao";
import { ProdutoIdadeCompra } from "./produtoIdadeCompra";
import { ProdutoIdadeEmprestimo } from "./produtoIdadeEmprestimo";
import { ProdutoIdadeSaque } from "./produtoIdadeSaque";

export class Produto {
  public id!: number | string | null;
  public ativo!: boolean;
  public nome!: string;
  public tipoProduto!: string;
  public esteira!: EsteiraModelo;
  public horaCorte!: string;
  public validaBanco!: boolean;
  public qtdContratos!: number;
  public validarPor!: string;
  public faixaIdade1!: number;
  public faixaIdade2!: number;
  public iof!: string;
  public financia!: boolean;
  public prefixo!: string;
  public mascara!: string;
  public calculaDV!: boolean;
  public consisteIdadeSaque!: string;
  public codigoMotor!: number;
  public codigoTipoLiberacao!: number;
  public codigoTipoQuitacao!: number;
  public valorMinLimite!: number;
  public percentCompra!: number;
  public percentSaque!: number;
  public limiteSaque1!: number;
  public limiteSaque2!: number;
  public valorMinContratado!: number;
  public valorMinParcela!: number;
  public valorMaxParcela!: number;
  public percentMargem!: number;
  public tabelaIdadeEmprestimo!: ProdutoIdadeEmprestimo[];
  public tabelaIdadeCartao!: ProdutoIdadeCartao[];
  public tabelaIdadeSaque!: ProdutoIdadeSaque[];
  public tabelaIdadeCompra!: ProdutoIdadeCompra[];
}